import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { ICalendarData } from "common/records/Calendar";

export const RECEIVE_CALENDAR = "@calendars/RECEIVE_CALENDAR";
export const RECEIVE_CALENDARS = "@calendars/RECEIVE_CALENDARS";
export const RECEIVE_CRONOFY_URL = "@calendars/RECEIVE_CRONOFY_URL";

export const CalendarActions = {
  receiveCalendar: (calendar: Partial<ICalendarData>) => createAction(RECEIVE_CALENDAR, { calendar }),
  receiveCalendars: (calendars: Partial<ICalendarData>[]) => createAction(RECEIVE_CALENDARS, { calendars }),
  receiveCronofyUrl: (url: string) => createAction(RECEIVE_CRONOFY_URL, { url }),
};

export type CalendarActions = ActionsUnion<typeof CalendarActions>;
